import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken, showToast } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  handleErrorResponseType,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * リクエストされたCSVファイルからタグ情報の登録を一階層単位で行う。
 *
 * @param {string} apiToken - API通信に使用するトークン。
 * @param {File} uploadFile - インポートするためのファイル。
 * @param {Object} options - インポートオプション。`depth`（タグの階層）と
 *                           オプションで`parentId`（親タグのID）を含む。
 * @returns {Function} Redux dispatch関数
 */
const importOneLayerTags = (apiToken, uploadFile, options) => dispatch => {
  consolelog('[API CALL] importOneLayerTags()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_IMPORT_ONE_LAYER_TAGS.replace(
    '{depth}',
    options.depth,
  );
  const { cancelToken, cancelTokenKey } =
    createCancelToken('importOneLayerTags');
  const headers = { 'content-type': 'multipart/form-data' };
  const params = new FormData();
  params.append('uploadFile', uploadFile);
  if (options.parentId) {
    params.append('parentId', options.parentId);
  }
  params.append('cancelToken', cancelToken);
  const buttonName = i18nMessages['userPrompt.button.close'];
  const button = [{ name: buttonName, type: 1 }];
  return axios
    .post(url, params, { headers })
    .then(res => {
      delCancelToken(cancelTokenKey);
      if (res.data && res.data.result) {
        showToast(i18nMessages['toast.message.tag.import']);
      } else if (res.data.errorMessages) {
        dispatch({
          type: actionTypes.OPEN_IMPORT_ERROR_DIALOG,
          errorMessages: res.data.errorMessages,
        });
      } else {
        dispatch({
          type: actionTypes.OPEN_USER_PROMPT,
          promptMessage: i18nMessages['userPrompt.message.failureImport'],
          buttonArray: button,
        });
      }
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.tags);
      }
    })
    .finally(() => {
      dispatch({ type: actionTypes.CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG });
    });
};

export default importOneLayerTags;
